import BaseAPI from "../api";

const path: string = "/advisor-student";

export type listType = {
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
  advisor_group?: string;
  sDate?: string;
  eDate?: string;
  advisorTypeId?: number;
};

export class advisorStudentApi extends BaseAPI {
  static getAllAdvisorStudentWithUserLogin(query?: listType): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }

  static getAllAdvisorStudentWithIdStudent(query?: listType): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }

  static getAdvisorStudentById(id: number, token?: string): Promise<any> {
    if (!token) {
      return this.api.get(`${path}/${id}/find-one`);
    } else {
      console.log('getAdvisorStudentById', token);
      return this.api.get(`${path}/${id}/find-one`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    }
  }

  static createAdvisorStudent(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static updateAdvisorStudent(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteAdvisorStudent(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static downloadFile(id: number): Promise<any> {
    return this.api.get(`${path}/advisor-student-file/${id}/download`, {
      responseType: "arraybuffer",
    });
  }

  static reportListEmployee(query?: listType): Promise<any> {
    return this.api.get(`${path}/list/employee`, {
      params: { ...query },
    });
  }

  static updloadConsultFile(id: number, body: any): Promise<any> {
    return this.api.post(`${path}/${id}/upload`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}
